import { EditCustomerCard, Typography } from '@maia/ui';
import { createFileRoute, Link } from '@tanstack/react-router';
import { getCustomerOptions } from './../../../../../features/customer/customer/queryOptions';

export const Route = createFileRoute(
  '/_authenticated/customers/$guid/edit/_layout/',
)({
  component: RouteComponent,
  loader: ({ context: { queryClient }, params: { guid } }) =>
    queryClient.ensureQueryData(getCustomerOptions(guid)),
});

function RouteComponent() {
  const data = Route.useLoaderData();

  return (
    <div className="area-page-content content-grid">
      <div className="flex flex-col gap-48 w-[472px]">
        <section>
          <Typography
            as="h3"
            variant="body-s"
            weight="medium"
            className="mb-24"
          >
            Reguliere wijziging
          </Typography>
          <ul className="flex flex-col gap-24">
            <Link
              to="/customers/$guid/edit/contact"
              params={{
                guid: data.guid,
              }}
            >
              <EditCustomerCard
                icon="message"
                label="Contactgegevens wijzigen"
                subtitle="E-mailadres en telefoonnummer"
              />
            </Link>
            <Link
              to="/customers/$guid/edit/address"
              params={{
                guid: data.guid,
              }}
            >
              <EditCustomerCard
                icon="home"
                label="Adres wijzigen"
                subtitle="Woonadres en ingangsdatum"
              />
            </Link>
            <Link
              to="/customers/$guid/edit/payment"
              params={{
                guid: data.guid,
              }}
            >
              <EditCustomerCard
                icon="credit-card"
                label="Betaalgegevens wijzigen"
                subtitle="Rekeningnummer en betaaltermijn"
              />
            </Link>
            <Link to="/customers/$guid/edit/personal-data"
            params={{
              guid: data.guid,
            }}>
             <EditCustomerCard
              icon="user"
              label="Persoonsgegevens wijzigen"
              subtitle="Naam, initialen of aanspreekvorm"
              />
            </Link>
          </ul>
        </section>
        {/* <section>
          <Typography
            as="h3"
            variant="body-s"
            weight="medium"
            className="mb-24"
          >
            Bijzondere wijziging
          </Typography>
          <ul className="flex flex-col gap-24">
            <EditCustomerCard
              icon="ankh"
              label="Polis wijzigen bij overlijden"
              subtitle="Wijzig uw polis bij overlijden"
            />
          </ul>
        </section> */}
      </div>
    </div>
  );
}
